module.exports = __webpack_public_path__ + "static/media/logo_black.3a473b5f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo_black.svg
// module id = 414
// module chunks = 36